
export default function About() {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-black to-emerald-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Experts en Logistique Florale
            </h2>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed">
              <strong>GO BACK LOGISTIQUE</strong> est une entreprise spécialisée dans le transport et la livraison de fleurs, forte de plusieurs années d'expérience dans le secteur de la logistique florale.
            </p>
            <p className="text-lg text-gray-200 mb-6 leading-relaxed">
              Nous mettons notre expertise logistique au service des <strong>fleuristes</strong>, <strong>grossistes</strong> et <strong>professionnels du secteur floral</strong>, en garantissant un service fiable, rapide et soigné pour tous vos besoins de transport de fleurs et plantes.
            </p>
            <p className="text-lg text-gray-200 mb-8 leading-relaxed">
              Implantés au <strong>Marché International de Rungis</strong>, au Pavillon des Fleurs, nous disposons d'un stand entièrement dédié à la gestion et à l'acheminement optimal de vos fleurs et plantes, partout où vous en avez besoin.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-white">Depuis 2020</div>
                  <div className="text-sm text-gray-300">à votre service</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-white">Rungis</div>
                  <div className="text-sm text-gray-300">Pavillon des Fleurs</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/c8d14922b1046a7d836bd004cc0df25a.jpg"
              alt="Logistique florale professionnelle"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-emerald-600 text-white p-6 rounded-xl shadow-xl max-w-xs">
              <div className="text-3xl font-bold mb-1">100%</div>
              <div className="text-emerald-100">Satisfaction client garantie</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}